module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partial-footer"
  }, [_c('div', {
    staticClass: "space-30"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "space-30"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "space-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row font-16 text-center-xs text-center-sm"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "bold font-18"
  }, [_vm._v("Loca.Shop")]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'use_terms'
      }
    }
  }, [_vm._v("Termos de Uso")])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'privacy_policy'
      }
    }
  }, [_vm._v("Políticas de privacidade")])], 1), _vm._v(" "), _c('div', {
    staticClass: "space-30 hidden-md hidden-lg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "bold font-18"
  }, [_vm._v("Locatários")]), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Cadastro/Login")])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'my_rents'
      }
    }
  }, [_vm._v("Minhas locações")])], 1), _vm._v(" "), _c('div', {
    staticClass: "space-30 hidden-md hidden-lg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "bold font-18"
  }, [_vm._v("Locadoras")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.config.adminURL,
      "target": "_blank"
    }
  }, [_vm._v("Painel de gestão")])]), _vm._v(" "), _c('div', {
    staticClass: "space-30 hidden-md hidden-lg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    staticClass: "img-responsive-center",
    attrs: {
      "src": _vm.imageUrl('locashop-symbol.png'),
      "alt": "Loca.Shop - Aluguel online de produtos"
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "space-40"
  }), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center padding-lateral-30"
  }, [_c('div', {
    staticClass: "font-25"
  }, [_vm._v("Gerencie seus cadastros de forma simples e segura!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-orange-color"
  }, [_c('div', {
    staticClass: "space-10"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('div', {
    staticClass: "space-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "font-14"
  }, [_vm._v("CNPJ: 33.596.756/0001-02 | © 2019 - Todos os direitos reservados")]), _vm._v(" "), _c('div', {
    staticClass: "space-40"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7cf5f1ef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/partials/PartialFooter.vue
// module id = 311
// module chunks = 18